import React from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { alpha, styled } from "@mui/material/styles";

const OptionSx = {
  whiteSpace: "unset",
  wordWrap: "break-word",
  fontSize: "0.75rem",
};

const CustomInput = styled((props) => (
  <TextField variant="standard" {...props} />
))(({ theme }) => ({
  "& .MuiInputBase-root": {
    borderRadius: 3,
    position: "relative",
    backgroundColor: theme.palette.mode === "light" ? "#00000029" : "#1A2027",
    border: "1px solid",
    borderColor: theme.palette.mode === "light" ? "#E0E3E7" : "#2D3843",
    fontSize: 11,
    width: "100%",
    padding: "1px 3px",
    transition: theme.transitions.create([
      "border-color",
      "background-color",
      "box-shadow",
    ]),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    "&:focus-within": {
      boxShadow: `${alpha(theme.palette.primary.main, 0.15)} 0 0 0 0.1rem`,
      borderColor: theme.palette.primary.main,
    },
  },
  "& .MuiInputBase-input": {
    padding: "0px 0px 0px 0px !important",
  },
  "& .MuiAutocomplete-endAdornment": {
    "& .MuiAutocomplete-clearIndicator": {
      "& .MuiSvgIcon-root": {
        fontSize: "1rem",
      },
    },
  },
}));

export default function CustomAutoComplete({
  value = "",
  inputValue = "",
  loading = false,
  disabled = false,
  options = [],
  onChange = () => {},
  onInputChange = () => {},
  inputSx = {},
  inputProps = {},
  customSx = {},
}) {
  return (
    <Autocomplete
      id="autocomplete-search"
      sx={customSx}
      filterOptions={(options) => options}
      options={options}
      loading={loading}
      autoComplete
      includeInputInList
      value={value}
      inputValue={inputValue}
      onChange={onChange}
      onInputChange={onInputChange}
      disabled={disabled}
      renderInput={(params) => (
        <CustomInput
          {...params}
          inputProps={{ ...params.inputProps, ...inputProps }}
          InputProps={{ ...params.InputProps, disableUnderline: true }}
          sx={inputSx}
        />
      )}
      renderOption={(props, option) => {
        return (
          <li {...props}>
            <Box component="span" sx={OptionSx}>
              {option}
            </Box>
          </li>
        );
      }}
    />
  );
}
